
import styled from 'styled-components';
import WithDirection from '@iso/lib/helpers/rtl';

const FormListWrap = styled.div`
    .ant-pagination-item-active{
        color: #fff;
        background-color: #0B2A1B;
        border-color: #0B2A1B;
        a{
            color: #fff !important;
        }
    }
`;

export default WithDirection(FormListWrap);